import { render, staticRenderFns } from "./reson.vue?vue&type=template&id=5650f891&scoped=true&"
import script from "./reson.vue?vue&type=script&lang=js&"
export * from "./reson.vue?vue&type=script&lang=js&"
import style0 from "./reson.vue?vue&type=style&index=0&id=5650f891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650f891",
  null
  
)

export default component.exports